import hortmag from './hortmag';

export { default as antiquetrader } from './antiquetrader';
export { default as artsandcraftshomes } from './artsandcraftshomes';
export { default as hortmag } from './hortmag';
export { default as militarytrader } from './militarytrader';
export { default as numismaticnews } from './numismaticnews';
export { default as oldcarsweekly } from './oldcarsweekly';
export { default as periodHomes } from './period_homes';
export { default as scriptmag } from './scriptmag';
export { default as sportscollectorsdigest } from './sportscollectorsdigest';
export { default as traditionalbuilding } from './traditionalbuilding';
export { default as traditionalbuildingshow } from './traditionalbuildingshow';
export { default as woodshopnews } from './woodshopnews';
export { default as writersdigest } from './writersdigest';

export enum SiteId {
  HORTMAG = 'hortmag',
  ARTSANDCRAFTSHOMES = 'artsandcraftshomes',
  WOODSHOPNEWS = 'woodshopnews',
  TRADITIONALBUILDING = 'traditionalbuilding',
  PERIOD_HOMES = 'period-homes',
  TRADITIONALBUILDINGSHOW = 'traditionalbuildingshow',
  NUMISMATICNEWS = 'numismaticnews',
  OLDCARSWEEKLY = 'oldcarsweekly',
  SPORTSCOLLECTORSDIGEST = 'sportscollectorsdigest',
  ANTIQUETRADER = 'antiquetrader',
  MILITARYTRADER = 'militarytrader',
  WRITERSDIGEST = 'writersdigest',
  SCRIPTMAG = 'scriptmag',
}

const SITE_ID_REMAP = {
  periodhomes: SiteId.PERIOD_HOMES,
} as Record<string, SiteId>;

export const getHostname = (domain: string) => {
  const hostname = domain
    ?.replace('.com', '')
    ?.replace('.net', '')
    ?.replace('.org', '');

  return SITE_ID_REMAP[hostname] ?? hostname;
};

// Simplify imports for storybook
export const defaultTheme = hortmag;
